import { useEffect, useState, useRef } from 'react';
//import TextField from '@mui/material/TextField';
import ComponentTable from '../../../Components/Table/Index';
import { Column } from '../../../Components/Table/Types';
//import {
//  ParagraphValores,
//  ParagraphTextoValores,
//  ContainerValores,
//} from './ContasPagarPesquisarStyle';
import * as Icon from '@mui/icons-material/';
import { /*Form,*/ useNavigate } from 'react-router-dom';
import { /*Form, Formik, Field,*/ FormikProps } from 'formik';
import { Box /*,MenuItem, Container, IconButton*/ } from '@mui/material';
import * as path from '../../../../routes/RoutesNames';
import ContaPagarController from '../../../../controllers/ContaPagarController';
import { formatarData } from '../../../../shared/utils/helpers/date';
import useContasPagarVisualizar from '../../../../hooks/useContasPagarVisualizar';
import { ButtonMenu } from '../../../../shared/components/ButtonMenu';
import { toast } from 'react-toastify';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { Button } from '../../../../shared/components/button/Button';
import { formatCurrency } from '../../../../shared/utils/helpers/numbers';
import Status from '../../../Components/Status/Index';
import { Loader } from '../../../../shared/components/Loader';
import FormBuilder from '../../../../shared/components/FormBuilder';
import SummaryCards from '../../../../shared/components/SummaryCards/SummaryCards';
import LoadingButton from '@mui/lab/LoadingButton';
import Api from '../../../../services/Api';
import { openBase64InNewTab } from '../../../../shared/utils/helpers/base64';

interface Row {
  cpp_status: string;
  cpp_id: number;
  codigoConta: number;
  cpp_datavencimento: Date;
  FornVend: string;
  cpp_valor: number;
  cpp_saldo: number;
  parcela: number;
  cp_descricao: string;
  BtnMenu?: JSX.Element;
}

export default function ContasPagar() {
  const navigate = useNavigate();
  const formikRef = useRef<FormikProps<any>>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const tableColumns: Column[] = [
    {
      id: 'Codigo', label: 'Código Parcela', minWidth: 0, align: 'center', hidden: true, maxWidth: undefined },
    { id: 'CodigoConta', label: 'Código', minWidth: 0, align: 'center', maxWidth: undefined },
    { id: 'Cliente', label: 'Pessoa', minWidth: 0, maxWidth: undefined },
    { id: 'Parcela', label: 'Parcela', minWidth: 0, maxWidth: undefined },
    { id: 'Vencimento', label: 'Vencimento', minWidth: 0, maxWidth: undefined },
    { id: 'Status', label: 'Status', minWidth: 0, align: 'center', maxWidth: undefined },
    { id: 'ValorPre', label: 'Valor Parcela', minWidth: 0, align: 'center', maxWidth: undefined },
    { id: 'Descricao', label: 'Descrição', minWidth: 0, maxWidth: undefined },
    { id: 'BtnMenu', label: '', width: 60, minWidth: 0, maxWidth: undefined },
  ];
  const [tableRows, setTableRows] = useState<Row[]>([]);

  const statusOptions = [
    { value: 'Todos', label: 'Todos' },
    { value: 'Em Aberto', label: 'Em Aberto' },
    { value: 'Atrasado', label: 'Atrasado' },
    { value: 'Pago', label: 'Pago' },
    { value: 'Excluida', label: 'Excluída' },
  ]

  const fields = [
    { name: 'cpp_status', type: 'select', label: 'Status', options: statusOptions, col: 2 },
    { name: 'cp_id', type: 'number', label: 'Código', col: 2 },
    { name: 'cpp_datainc_ini', type: 'date', label: 'Data Início', col: 2 },
    { name: 'cpp_datainc_fim', type: 'date', label: 'Data Fim', col: 2 },
    { name: 'cpp_vencimento_ini', type: 'date', label: 'Data Vencimento Início', col: 2 },
    { name: 'cpp_vencimento_fim', type: 'date', label: 'Data Vencimento Fim', col: 2 },
    { name: 'nome', type: 'text', label: 'Pessoa', col: 2 },
    { name: 'cpp_valor', type: 'text', label: 'Valor', col: 2 },
    { name: 'cpp_id', type: 'text', label: 'Parcela', col: 2 },
    { name: 'cp_descricao', type: 'text', label: 'Descrição', col: 2 },
    { type: 'submit', icon: (<Icon.Search style={{ fontSize: '28px' }} />) },
  ]

  const summaryCardsFields = [
    { name: 'ValorReceber', label: 'Valor a Receber', col: 4 },
    { name: 'ValorPago', label: 'Valor Pago', col: 4 },
    { name: 'ValorRenegociado', label: 'Valor Renegociado', col: 4 }
  ];

  const initialValues = {
    cp_id: null,
    cpp_status: 'Todos',
    cpp_datainc_ini: formatarData(new Date((new Date()).setMonth(new Date().getMonth() - 1))),
    cpp_datainc_fim: formatarData(new Date()),
    cpp_vencimento_ini: formatarData(new Date((new Date()).setMonth(new Date().getMonth() - 1))),
    cpp_vencimento_fim: formatarData(new Date()),
    nome: '',
    cpp_valor: null,
    cpp_id: null,
    cp_descricao: '',
    ValorReceber: null,
    ValorPago: null,
    ValorRenegociado: null,
  };
  const handleNavigation = async (): Promise<void> => {
    navigate(path.ContasPagarCadastrar);
  };

  const handleEditItem = (item: any, duploClick = false, duploClickId = 0) => {
    const status = item?.cpp_status || item?.Status?.props?.text;
    if (status === 'EXCLUIDA') {
      return toast('Não é possível interagir com uma parcela que foi excluída!', {
        type: 'error',
      });
    }
    if (duploClick) {
      navigate(path.ContasPagarAtualizar.replace(':id', duploClickId.toString()), { state: { duploClick: true } });
    }
    else {
      navigate(path.ContasPagarAtualizar.replace(':id', item.cpp_id.toString()));
    }
  };

  const handleEstornarItem = async (item: Row) => {
    if (item.cpp_status === 'PAGO') {
      const request: any = {
        cpp_id: item.cpp_id,
        operacao: 'ESTORNO',
        valorPago: item.cpp_valor,
        valorTotal: item.cpp_valor,
        dataPagto: formatarData(new Date()),
      };
      const response = await ContaPagarController.QuitarEstornar(request);
      if (response.StatusCode === 200) {
        toast('Estorno feito com sucesso!', {
          type: 'success',
        });

        refreshGrid();

      } else {
        toast('Erro ao realizar o estorno!', {
          type: 'error',
        });
      }
    } else {
      toast(
        'Não é possível Estornar uma conta com status diferente de Pago!',
        {
          type: 'error',
        }
      );
    }
  };

  const handleQuitarItem = async (item: Row) => {
    if (item.cpp_status === 'EM ABERTO' || item.cpp_status === 'Em Aberto' || item.cpp_status === 'ATRASADO') {
      const request: any = {
        cpp_id: item.cpp_id,
        operacao: 'QUITAÇÃO',
        valorPago: item.cpp_valor,
        valorTotal: item.cpp_valor,
        dataPagto: formatarData(new Date()),
      };
      const response = await ContaPagarController.QuitarEstornar(request);
      if (response.StatusCode === 200) {
        toast('Quitação feita com sucesso!', {
          type: 'success',
        });

         refreshGrid();
         
      } else {
        toast('Erro ao realizar a quitação!', {
          type: 'error',
        });
      }
    } else {
      toast(
        'Não é possível quitar uma conta com status diferente de Em Aberto!',
        {
          type: 'error',
        }
      );
    }
  };

  const refreshGrid = () => {
  // Pega os valores atuais do formRef (que você já tem)
  const currentValues = formRef.current?.values || initialValues;
  handleSubmit(currentValues);
};

  const handleDeleteItem = async (item) => {
    if (item.cpp_status?.toLowerCase() === 'pago') return toast(
      'Não é possível excluir uma conta que já foi paga!',
      { type: 'error' }
    );

    const res = await ContaPagarController.Excluir({
      cp_id: item.codigoConta,
      cpp_id: item.cpp_id
    });

    // console.log(res.Message?.split('\n')?.[0])
    if (res.StatusCode && res.StatusCode >= 200 && res.StatusCode < 300) return setTableRows((items) => items.filter(i => i.Codigo !== item.cpp_id));
    if (res.StatusCode === 400 && res.Message) return toast(res.Message?.split('\n')?.[0], { type: 'error' });
    toast(res.Data, { type: 'error' });
  };

  const [loadingRelatorio, setLoadingRelatorio] = useState(false);

  const downloadRelatorio = async () => {
    const v = formRef?.current?.values;
    try {
      setLoadingRelatorio(true);
      const response = await Api.post(`api/relatorio/ContasPagar`, { dataInicio: v.cpp_datainc_ini, dataFim: v.cpp_datainc_fim, status: v.cpp_status});
      openBase64InNewTab(response.data.base64, "my-file", "application/pdf");
      setLoadingRelatorio(false);
    }
    catch (e) {
      console.error(e)
      toast('Erro ao baixar relatório', { type: 'error' });
      setLoadingRelatorio(false);
    }
  }

  const statusColor = (s: string) => ({
    pago: '#4caf50',
    'em aberto': '#42a5f5',
    atrasado: '#ef5350',
    'excluida': '#999'
  })[s.toLowerCase()] || 'info'

  const handleSubmit = async (values: any) => {
    setLoading(true)

    const DataRows: any = [];
    const Response = await ContaPagarController.Listar(values);
    if (Response.StatusCode === 200 && Response?.Data?.length > 0) {
      Response.Data.map((item: Row) => {
        const statusExcluida = item.cpp_status === 'EXCLUIDA';
        DataRows.push({
          BtnMenu: statusExcluida ? (
            <ButtonMenu
              items={[]}
              disabled={true}
            />
          ) : (
            <ButtonMenu
              items={[
                {
                  onClick: () => {
                    handleOpenModalSearchProduct(item.cpp_id);
                  },
                  menu: 'Abrir',
                },
                {
                  onClick: () => {
                    handleEditItem(item);
                  },
                  menu: 'Editar',
                },
                {
                  onClick: () => {
                    handleEstornarItem(item);
                  },
                  menu: 'Estornar',
                },
                {
                  onClick: () => {
                    handleQuitarItem(item);
                  },
                  menu: 'Quitar',
                },
                {
                  onClick: () => {
                    handleDeleteItem(item);
                  },
                  menu: 'Excluir', confirmar: `Excluir a conta a pagar "${item.cp_descricao ?? ''}"? Esta ação não pode ser desfeita.`,
                },
              ]}
            />
          ),
          Codigo: item.cpp_id,
          CodigoConta: item.codigoConta,
          Parcela: item.parcela,
          Vencimento: item.cpp_datavencimento,
          ValorPre: formatCurrency(item.cpp_valor),
          Status: item?.cpp_status && (
            <Status text={item?.cpp_status || ''} color={statusColor(item?.cpp_status)} />
          ),
          Cliente: item.FornVend,
          Saldo: item.cpp_saldo,
          Descricao: item.cp_descricao,
        });
      });
      setTableRows(DataRows);
    } else if (Response.StatusCode === 204 && Response?.Data?.length === 0) {
      toast('Não há registros cadastrados.', {
        type: 'warning',
      });
    } else {
      toast(Response?.Data, {
        type: 'success',
      });
    }
    setLoading(false)
  };

  const {
    handleOpenModalSearchProduct,
  } = useContasPagarVisualizar();

  useEffect(() => {
    handleSubmit(initialValues)
  }, []);

  const formRef = useRef(null);

  return (
    <Loader loading={loading}>
      <Box>
        <HeaderComponent
          text={'Contas a Pagar'}
          ButtonRight={
            <>
              <Button
                className={''}
                variant='success'
                onClick={handleNavigation}
                iconStart={<Icon.Add />}
                title={'Incluir'}
              />
              <LoadingButton
                loading={loadingRelatorio}
                loadingPosition="start"
                startIcon={<Icon.FileDownload />}
                variant="outlined"
                onClick={downloadRelatorio}
                 sx={{
                  color: '#fff',
                  backgroundColor: '#1976d2',
                  '&:hover': { backgroundColor: '#1769bb' },
                  textTransform: 'none',
                  marginLeft: '16px',
                  fontSize: '16px',
                  '&&.Mui-disabled': {
                    color: '#ddd',
                  },
                }}
              >
                <p>Relatório</p>
              </LoadingButton>
            </>
          }
        />
        <SummaryCards fields={summaryCardsFields} initialValues={initialValues} />
        <FormBuilder innerRef={formRef} fields={fields} initialValues={initialValues} onSubmit={handleSubmit} gap='gap-3' />
        <ComponentTable columns={tableColumns} rows={tableRows} tableHeight={'50vh'} onRowDoubleClick={(row) => {
          handleEditItem(row, true, row.Codigo);
        }} />
      </Box>
    </Loader>
  );
}
